<template>
  <el-card>
    <div class="wrap-rub center">
      <div class="wrap-left">
        <div class="title">
          <img src="https://public-static-edu.codemao.cn/redboat/courseManage/综合表现.png" />
          <h3>综合表现！</h3>
        </div>
      </div>
    </div>
    <div id="myChart" style="height:320px;margin: 0 auto; margin-top: -20px;"></div>
  </el-card>
</template>

<script>
import echarts from 'echarts'
import { Card } from 'element-ui'

const option = {
  tooltip: {
    show: true
  },
  legend: {
    bottom: -5,
    data: ['本节课表现', '过往平均表现'],
    itemGap: 65,
    textStyle: {
      color: [],
      fontSize: 12
    },
    selectedMode: 'multiple',
    itemWidth: 8,
    itemHeight: 8
  },
  radar: {
    indicator: [
      { name: '积极完成\n课堂作业', max: 5 },
      { name: '善于分享\n乐于助人', max: 5 },
      { name: '程序设计\n思路清晰', max: 5 },
      { name: '顺利实现\n项目功能', max: 5 },
      { name: '不断调试\n优化程序', max: 5 },
      { name: '发挥创意\n解决问题', max: 5 }
    ],
    center: ['50%', '50%'],
    radius: '60%',
    splitNumber: 5,
    name: {
      color: '#666',
      fontSize: 12,
      lineHeight: 16,
      rich: {
        a: {
          // 没有设置 `lineHeight`，则 `lineHeight` 为 56
        }
      }
    },
    splitLine: {
      lineStyle: {
        color: '#BFBFBFFF',
        type: 'dashed'
      }
    },
    splitArea: {
      show: false
    },
    axisLine: {
      show: false
    }
  },
  series: [
    {
      name: '本节课表现',
      type: 'radar',
      lineStyle: {
        width: 2,
        opacity: 1
      },
      data: [{ value: [1, 1, 5, 5, 5, 5] }],
      symbol: 'none',
      itemStyle: {
        normal: {
          color: '#00C882'
        }
      },
      areaStyle: {
        normal: {
          opacity: 0.2
        }
      },
      zlevel: 9
    },
    {
      name: '过往平均表现',
      type: 'radar',
      lineStyle: {
        width: 2,
        opacity: 1
      },
      data: [{ value: [0, 0, 0, 0, 0, 0] }],
      symbol: 'none',
      itemStyle: {
        normal: {
          color: '#0656FF'
        }
      },
      areaStyle: {
        normal: {
          opacity: 0.2
        }
      },
      zlevel: 8
    }
  ]
}

export default {
  components: {
    'ElCard': Card
  },
  props: ['data'],
  data () {
    return {
      echarts: '',
      timer: null
    }
  },
  computed: {
    colors () {
      return ['#FFC206FF', '#FE9532FF', '#FC685DFF']
    }
  },
  watch: {
    'data': {
      handler (val) {
        this.$nextTick(() => {
          if (!Object.keys(val).length) return
          option.series[0].data[0].value = val.personal_assess_info.map(row => row.value)
          option.series[1].data[0].value = val.complex_personal_assess_info.map(row => row.value)
          this.initChart()
        })
      },
      immediate: true
    }
  },
  methods: {
    initChart () {
      this.echarts = echarts.init(document.getElementById('myChart'))
      this.echarts.showLoading({
        text: '',
        color: '#00FAFF',
        textColor: '#fff',
        maskColor: 'rgba(255, 255, 255, 0)',
        zlevel: 0
      })
      this.timer = setTimeout(() => {
        this.echarts.setOption(option)
        this.echarts.hideLoading()
      }, 1000)
    }
  },
  beforeDestroy () {
    this.timer = null
  }
}
</script>

<style lang="stylus" scoped>
@import './view.styl';
</style>
